import { useMediaQuery } from '@mui/material';
// Tablet or mobile
export function isSmallScreen(theme) {
    return useMediaQuery(theme.breakpoints.down('md'));
}
// Mobile only
export function isMobileScreen(theme) {
    return useMediaQuery(theme.breakpoints.down('sm'));
}
